import React, { Component } from 'react';
import { AlertTriangle } from 'lucide-react';

class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to monitoring service here if needed
    console.error('💥 ErrorBoundary caught an error:', error, errorInfo);
  }

  handleReload = () => window.location.reload();

  renderFallback() {
    return (
      <main className="flex flex-col items-center justify-center h-screen px-4 bg-gray-100 text-gray-800">
        <section className="bg-white shadow-xl rounded-2xl p-8 max-w-md w-full text-center">
          <div className="flex justify-center mb-4">
            <AlertTriangle className="w-12 h-12 text-red-500" />
          </div>
          <h1 className="text-3xl font-bold mb-2">
            Oops, something went wrong
          </h1>
          <p className="text-base text-gray-600 mb-6">
            An unexpected error occurred. Please refresh the page or try again
            later.
          </p>
          <button
            onClick={this.handleReload}
            className="px-4 py-2 rounded-lg border border-gray-300 bg-gray-200 text-black font-semibold hover:bg-gray-300 transition"
            aria-label="Reload the page"
          >
            Reload Page
          </button>
        </section>
      </main>
    );
  }

  render() {
    return this.state.hasError ? this.renderFallback() : this.props.children;
  }
}

export default ErrorBoundary;
